import { useTranslation } from "react-i18next";

import { ContactType, IContact } from "../../models/Contact";
import getAddress from "../../utils/getAddress";
import Card from "../shared/Card/Card";

export default function ContactDetails({ contact }: { contact: IContact }) {
  const { t } = useTranslation("accounts");

  return (
    <>
      <Card title={t("Contact Details")} bodyClassName="p-4">
        <div className="space-y-4">

          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">{t("Name")}</dt>
              <dd className="mt-1 text-sm text-gray-900">
                {contact.fullname}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">{t("Contact Type")}</dt>
              <dd className="mt-1 text-sm text-gray-900">{t(ContactType[contact.contactType!])}</dd>
            </div>
          </dl>

          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">{t("Phone number")}</dt>
              <dd className="mt-1 text-sm text-gray-900">{contact.telephone1}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">{t("Email address")}</dt>
              <dd className="mt-1 text-sm text-gray-900">{contact.email}</dd>
            </div>
          </dl>

          <dl className="gap-x-4 gap-y-8">
            <div>
              <dt className="text-sm font-medium text-gray-500">{t("Address")}</dt>
              <dd className="mt-1 text-sm text-gray-900">{getAddress(contact)}</dd>
            </div>
          </dl>

        </div>
      </Card>
    </>
  );
}
